/**
 * Route for `custom-payout-rules-per-influencer-tier`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomPayoutRulesPerInfluencerTierPage } from "../features/custom-payout-rules-per-influencer-tier/CustomPayoutRulesPerInfluencerTierPage";

export const customPayoutRulesPerInfluencerTierRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-payout-rules-per-influencer-tier",
	component: CustomPayoutRulesPerInfluencerTierPage,
});

export default customPayoutRulesPerInfluencerTierRoute;
